<template>
  <div >
    <el-form v-if="isLoading" v-loading="!isLoading" ref="examPaperForm" id="examPaperForm" :model="examPaperInfo" label-width="120px" label-suffix=":">
      <!--移动端展示头部-->
      <div v-if="pageShow==1" class="dtk_title_box">
        <div class="dtk_scantron_btn">
          <el-button @click="cutShow" class="scantron_btn">答题卡<i :class="scantron?'icon_right_top':'icon_right_bottom'"></i></el-button>
          <span v-if="showType!=3" >得分:{{examPaperInfo.GET_SCORE}}/{{examPaperInfo.TOTAL_SCORE}}</span>
          <span class="autside" style="margin-right: 10px">用时:{{countTimeStr}}</span>
        </div>
        <el-row v-show="scantron">
          <el-col :span="1" align="middle"
                  v-for="(questionOne,questionIndex) in examPaperInfo.dtkQuestionList" :key="'dtk_'+questionOne.questionId + '_' + questionIndex"
                  :class="(questionOne.IF_DO==1?'dtk_div_do':'dtk_div_notdo')+((questionOne.eqType == 7 || questionOne.eqType == 9)?' dtk_border':' ')"
                  @click.native="dtkClick(questionIndex)"
          >
            <el-badge v-if="showType!=3 && questionOne.IF_RIGHT" class="sub_reset"
                      :value="questionOne.IF_RIGHT==1?'√':'×'" :type="questionOne.IF_RIGHT==1?'warning':'danger'"
            >
              <span 
                    style="background: #green;"
              >{{questionIndex+1}}</span>
            </el-badge>
            <span v-else 
                  :class="(examPaperInfo.ZD_DO_WAY == 1 && nowCheckQuestionDtk == questionIndex)?'dtk_div_checked':''"
            >{{questionIndex+1}}</span>
          </el-col>
        </el-row>
      </div>
      <!--PC端展示头部-->
      <div v-else class="dtk_title_box" :style="initLookType==1?'position:static;margin-top:10px':''" v-show="examPaperInfo.setInfo.cssSet.cssType ==1">
        <!--pc端默认样式头部-->
        <el-row>
          <el-col :xs="6" :sm="3" :md="3" :lg="3" :xl="3">
            <div class="dtk_scantron">
              <p>{{examPaperInfo.EP_NAME}}</p>
            </div>
          </el-col>
          <el-col :xs="12" :sm="16" :md="16" :lg="16" :xl="16" :span="1">
            <el-row>
              <el-col :span="1" align="middle"
                      v-for="(questionOne,questionIndex) in examPaperInfo.dtkQuestionList" :key="'dtk_'+questionOne.questionId + '_' + questionIndex"
                      :class="(questionOne.IF_DO==1?'dtk_div_do':'dtk_div_notdo')+((questionOne.eqType == 7 || questionOne.eqType == 9)?' dtk_border':' ')"
                      @click.native="dtkClick(questionIndex)"
              >
                <el-badge v-if="showType!=3 && questionOne.IF_RIGHT" class="sub_reset"
                          :value="questionOne.IF_RIGHT==1?'√':'×'" :type="questionOne.IF_RIGHT==1?'warning':'danger'"
                >
                  <span 
                        style="background: #green;"
                  >{{questionIndex+1}}</span>
                </el-badge>
                <span v-else 
                      :class="(examPaperInfo.ZD_DO_WAY == 1 && nowCheckQuestionDtk == questionIndex)?'dtk_div_checked':''"
                >{{questionIndex+1}}</span>
                
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="6" :sm="5" :md="5" :lg="5" :xl="5">
            <div class="dtk_title">
              <p v-if="showType!=3" >得分:{{examPaperInfo.GET_SCORE}}/{{examPaperInfo.TOTAL_SCORE}}</p>
              <p class="autside">用时:{{countTimeStr}}</p>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 前置页面 -->
      <div v-if="paperShowType.openPrevFlag" class="question_box" :class="examPaperInfo.setInfo.cssSet.cssType ==1?'questionBigBox':''" :style="'top:'+examPaperHeight+'px;height:'+(screenHeight-116)+'px'" style="overflow: auto">
        <div :class="examPaperInfo.setInfo.cssSet.cssType ==1?'':'contents'">
          <div v-for="(one,index) in paperShowType.prevPageArr" :key="'prevPage_'+index">
            <div v-if="paperShowType.openPrevIndex == index">
                <div v-if="countDownObj.limitTime > 0 && countDownObj.limitTimePosition == 2" style="font-size:32px;font-weight:bold;text-align:center;padding-top:50px">
                  <CountDown v-if="countDownObj.forceRefresh" v-model="countDownObj" @timeEnd="timeEndCheckContinue" ></CountDown>
              </div>    
              <div v-if="one.defaultImg && one.defaultImg.length > 0" :style="examPaperInfo.setInfo.cssSet.cssType ==2?'text-align: center;':''" style="padding: 20px 0">
                <img :src="GLOBAL.getFileServeUrl()+one.defaultImg[0].downAddress" />
                <!--<img v-if="one.defaultImg" style="width:300px;height:300px;" src="./img/rsd-h3.png"/>-->
              </div>
              <div v-html="one.defaultText" style="background-color: #F1E7CA;"></div>
              <!-- @endTime="showQuestionInfo" -->
              <AudioPlay v-if="one.defaultRecord && one.defaultRecord.length > 0" :srcInfo="one.defaultRecord[0]" @endTime="prevPageAudioEnd" ></AudioPlay>
              <div class="records" v-if="one.ifCheckMike==1">
                <Record :initAudioSrc="one.mikeFile" :setInfo="{ifShowReslut:1,preparatTime:0,recordTime:10}" :showType="2"></Record>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 试题块显示 -->
      <!--<div v-if="paperShowType.openQuestionFlag" v-show="buttonType.hearingButton" ref="examPaper" class="question_box aaaa" :class="examPaperInfo.setInfo.cssSet.cssType ==1?'questionBigBox':'TOEFLStyle'  [initLookType==1?'initLookTypeStyle':'']" :style="'top:'+examPaperHeight+'px;'">-->
      <div v-if="paperShowType.openQuestionFlag" v-show="buttonType.hearingButton" ref="examPaper" class="question_box" :class="examPaperInfo.setInfo.cssSet.cssType ==1?'questionBigBox':'TOEFLStyle'" :style="initLookType==1?'position:static;':''+ 'top:'+examPaperHeight+'px;'">
        <!-- 试卷做题形式为 每次一道时 initDoQuestionInfo -->
        <div v-if="examPaperInfo.ZD_DO_WAY == 1" >
          <DoQuestion :initQuestionId="examPaperInfo.blockList[nowCheckBlock].questionList[nowCheckQuestion].PK_EXAM_QUESTION" 
            :initQuestionInfo="examPaperInfo.blockList[nowCheckBlock].questionList[nowCheckQuestion].questionInfo" 
            :initShowType="nowQuestionShowType" 
            :initStudentQuestionId="examPaperInfo.blockList[nowCheckBlock].questionList[nowCheckQuestion].studentQuestionId"
            v-model="examPaperInfo.blockList[nowCheckBlock].questionList[nowCheckQuestion].studentQuestionInfo"
            :initStuId="stuId" :studentExamPaperId="studentExamPaperId" :ifOperaRow=0
            :blockIndex="nowCheckBlock"
            :questionIndex="nowCheckQuestion"
            :maxIndex="examPaperInfo.blockList[nowCheckBlock].questionList.length"
            :initTablePageInfo="doQtablePageInfo"
            :parentCssSet="examPaperInfo.setInfo.cssSet"
            :initLookType="initLookType"
            :ifShowType="examPaperInfo.ZD_IF_SHOW_TYPE"
            @updateDtkState="updateDtkState"
            @updateStudentQuestionId="updateStudentQuestionId"
            @setButtonState="setButtonState"
            @changeQuestionState="changeQuestionState"
            @setCountDownInfo="setCountDownInfo"
            ref="question_info"
            :key="'question_info_'+nowCheckBlock+'_'+nowCheckQuestion"
            :heightChild =1
          ></DoQuestion>
          <!--@listenToChildEvent='showMsgfromChild'-->
        </div>
        <!-- 判断当前显示的第几个块  -->
        <div v-else >
          <div v-for="(blockOne,blockIndex) in examPaperInfo.blockList" name="aaaa" :key="'block_' + blockIndex" >
            <span style="font-size:16px;padding:10px;line-height:40px;">{{zmArr[blockIndex]+"、"+blockOne.BLOCK_NAME}}</span>
            <div v-for="(questionOne,questionIndex) in blockOne.questionList" :key="'question_info_'+blockIndex+'_'+questionIndex" ref="question_row" :id="'question_row_'+questionOne.PK_EXAM_QUESTION" >
              <DoQuestion 
                :initQuestionId="questionOne.PK_EXAM_QUESTION" 
                :initQuestionInfo="questionOne.questionInfo" 
                :initShowType="showType" 
                :initStudentQuestionId="questionOne.studentQuestionId" 
                v-model="questionOne.studentQuestionInfo"
                :initStuId="stuId" :studentExamPaperId="studentExamPaperId" :ifOperaRow=0
                :blockIndex="blockIndex"
                :questionIndex="questionIndex"
                :maxIndex="blockOne.questionList.length"
                :initTablePageInfo="doQtablePageInfo"
                :parentCssSet="examPaperInfo.setInfo.cssSet"
                :initLookType="initLookType"
                :ifShowType="examPaperInfo.ZD_IF_SHOW_TYPE"
                @updateDtkState="updateDtkState"
                @updateStudentQuestionId="updateStudentQuestionId"
                @setButtonState="setButtonState"
                @changeQuestionState="changeQuestionState"
                @setCountDownInfo="setCountDownInfo"
                ref="question_info"
                :heightChild =1
              ></DoQuestion>
            </div>
          </div>
        </div>
      </div>

      <!-- 题目信息提示栏 -->
      <div v-show="!buttonType.hearingButton" class="TOEFLStyle" >
        <div class="mmlmw">
          <div class="reviewbox">
            <table border="0" cellpadding="0" cellspacing="1">
              <tbody>
              <tr>
                <th width="30">No.</th>
                <th>Description</th>
                <th width="120">Status</th>
              </tr>

              <!--<tr v-for="(item,index) in dtkReviewQuestionList" :key="item.questionId" @click="getQuestionShowType(100,index)">-->
              <tr v-for="(item,index) in dtkReviewQuestionList" :key="item.questionId" @click="dtkClick(item.reviewDtkIndex)">
                <td class="one">{{index+1}}</td>
                <td class="two">
                  <div class="k" v-html="item.eqContent"></div>
                </td>
                <td class="three">
                  <strong v-if="item.IF_DO==1">Answered</strong>
                    <strong v-else-if="item.IF_SEE==1">Not Answered</strong>
                  <strong v-else>Not seen</strong>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!--<div v-if="examPaperInfo.ZD_DO_WAY == 1&&examPaperInfo.setInfo.cssSet.cssType ==2?true:false" style="text-align: center;position: absolute;left: 0;bottom: 0;right: 0;">-->
        <!--<span v-if="examPaperInfo.blockList[nowCheckBlock].questionList[nowCheckQuestion].questionInfo.prevSet && buttonType.openQuestionFlag">-->
                <!--<CountDown v-model="examPaperInfo.blockList[nowCheckBlock].questionList[nowCheckQuestion].questionInfo.prevSet"-->
                           <!--:key="'count_down_'+nowCheckBlock+'_'+nowCheckQuestion"-->
                <!--&gt;</CountDown>-->
        <!--</span>-->
      <!--</div>-->
      <!-- 显示形式为 每道题显示时,显示上一题 下一题  -->
      <el-row justify="center" class="BtnBigBox" :style="initLookType==1?'position:static;':''" v-if="examPaperInfo.setInfo.cssSet.cssType ==1?true:false">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"  >
          <div class="BtnBox">
            <template v-if="examPaperInfo.ZD_DO_WAY == 1">
              <span v-if="examPaperInfo.blockList[nowCheckBlock].questionList[nowCheckQuestion].questionInfo.prevSet && buttonType.openQuestionFlag">
                <CountDown v-model="examPaperInfo.blockList[nowCheckBlock].questionList[nowCheckQuestion].questionInfo.prevSet"
                  :key="'count_down_'+nowCheckBlock+'_'+nowCheckQuestion"
                ></CountDown>
              </span>
              <!-- 回到附件展示页面 -->
              <!-- 显示试题内容试题页面 -->
              <el-button type="primary" @click="changeQuestionType(1)" 
                v-if="!buttonType.openQuestionFlag"
              >试题</el-button>
              <el-button type="primary" @click="changeQuestionType(2)" 
                v-if="!buttonType.openFileFlag"
              >附件</el-button>
              <!-- 显示前置页面时 下一页的功能 -->
              <el-button type="primary" @click="changeQuestionType(3)" 
                v-if="buttonType.openPrevFlag"
              >CONTINUE</el-button>
              <span>
                {{nowCheckQuestion+1}}/{{examPaperInfo.blockList[nowCheckBlock].questionList.length}}
              </span>
              
              <el-button type="primary" @click="prevQuestion" 
                v-if="(nowCheckBlock > 0 || nowCheckQuestionDtk > 0)"
                :loading="fullscreenLoading"
              >上一题</el-button>
              
              <!-- v-if="!(nowCheckBlock == examPaperInfo.blockList.length && nowCheckQuestionDtk == examPaperInfo.blockList[nowCheckBlock].questionList.length-1)" -->
              <el-button type="primary" @click="nextQuestion" 
                v-if="!(that.nowCheckQuestionDtk == that.examPaperInfo.dtkQuestionList.length-1)"
                :loading="fullscreenLoading"
              >下一题</el-button>
            </template>
            <el-button type="primary" @click="saveExamPaper" v-if="(showType==3 || showType==4) && (that.nowCheckQuestionDtk == that.examPaperInfo.dtkQuestionList.length-1)"
              :loading="fullscreenLoading" class="affirm" 
            >{{showType==3?'交卷':'批改'}}</el-button>
            <el-button @click="cancelPage" class="close">取消</el-button>
          </div>
        </el-col>
      </el-row>
      <el-dialog
              title="感谢帮我们一起优化试卷！"
              :visible.sync="submitErrorInfo.centerDialogVisible"
              custom-class="top-el-dialog"
              width="30%">
        <div>
          <div class="el-dialog_div_1">
            <span class="el-dialogSpan">选择纠错类型 :</span>
            <el-select v-model="submitErrorInfo.ERROR_TYPE" placeholder="请选择">
              <el-option
                      v-for="item in submitErrorInfo.errorCorrectionOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="el-dialog_div_2">
            <span class="el-dialogSpan">描述错误内容 :</span>
            <el-input
                    type="textarea"
                    :rows="5"
                    maxlength="300"
                    placeholder="例如：真题32，Passage1 Q1题干中act单词拼写错误(最多输入300字)"
                    v-model="submitErrorInfo.ERROR_CONTENT">
            </el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="submitErrorInfo.centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitError">确 定</el-button>
        </span>
      </el-dialog>


    </el-form>
    <div v-else>
      试卷信息加载中!请稍等!
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import utils from '@/js/page/pageUtil.js'
import examUtils from '@/js/page/examUtil.js';
// import wx from 'weixin-js-sdk';
import CountDown  from '@/components/utils/CountDown.vue';
import DoQuestion from '@/components/exam/DoQuestion.vue';
 //音频播放组件
import AudioPlay  from './AudioPlay.vue';
//音频录制组件
import Record from '@/components/live/Record.vue'
import theConfirm from '../../../public/confirm/confirm.js'

export default {
  name: 'DoExamPaper',
  props: {
    //初始的展示类型  添加:0  修改页面:1  预览页面:2   做题页面:3  批改页面:4  结果查看页面:5
    initShowType: Number,
    //试卷主键
    initExamPaperId: Number,
    //学员主键
    initStuId:Number,
    //学员试卷主键
    initStudentExamPaperId:Number,
    //项目ID
    initProId:String,
    // 查看页面的显示状态 0:是默认根据试卷走  1为常规类型清除页面的样式设置
    initLookType:{
      type:Number,
      default:0
    }
  },
  components: {
    CountDown,
    AudioPlay,
    DoQuestion,
    Record
  },
  data() {
    return {
      //判断是移动端还是pc端 移动端：1     PC：2
      pageShow: 0,
      //答题卡show
      scantron:false,
      //页面展示类型   添加:0  修改页面:1  预览页面:2  做题页面:3  批改页面:4  结果查看页面:5
      showType:0,
      //试卷主键
      examPaperId: 0,
      //学员主键
      stuId:0,
      //学员试卷主键
      studentExamPaperId:0,
      //项目ID
      proId:"",
      //试卷的内容
      examPaperInfo:{
        questionList:[],
        ACTUAL_TIME_LENGTH:0
      },
      //是否进行预览
      isPreview:false,
      //保存按钮的状态
      fullscreenLoading:false,
      //计时的显示
//      countTimeStr:"用时:00:00:00",
      countTimeStr:"00:00:00",
      //当前点击选中的块
      nowCheckBlock:0,
      //当前点击选中的试题
      nowCheckQuestion:0,
      //当前选中的答题卡的试题下标
      nowCheckQuestionDtk:0,
      //当前选中的试题的 操作状态
      nowQuestionShowType:3,

      //做试卷的接口页面的配置信息
     
      //百利考试 做试卷的接口页面的配置信息
      tablePageInfo:{ tableId:17975, addPageId:11666, updatePageId:11677,timePageId:0},

      doQtablePageInfo:null,

       //crm 电子 做试卷的接口页面的配置信息
      //tablePageInfo:{ tableId:136, addPageId:769, updatePageId:770 },

      //试题页面高度
      examPaperHeight:30,
      //试卷信息是否加载完成
      isLoading:false,

      buttonType:{
        //是否打开附件页面
        openFileFlag:false,
        //是否打开前置页面
        openPrevFlag:false,
        //是否显示试题页面
        openQuestionFlag:true,
        //子题的 题目内容 不默认显示时 显示 按钮
        openScript:false,
        //子题有单独的题目附件时 显示按钮
        openPlayTalk:false,
        //continue按钮是否能点击
        continueDisabled:false,
        setIfConfirm:true,//听力需保存再下一步
        limitNext:true,//听力试题保存后允许下一步
        hearingButton:true,//切换review显示操作栏按钮
      },
      paperShowType:{
        //前置页面是否显示
        openPrevFlag:false,
        //试题是否显示
        openQuestionFlag:true,
        //试卷或试卷块的前置页面的内容
        prevPageArr:[],
        //当前打开的第几个前置页面
        openPrevIndex:-1
      },
        //review显示的答题卡信息
        dtkReviewQuestionList:[],
      screenHeight:'',
      switchTimeShow:true,//显示隐藏倒计时
      SHOWHIDE:'SHOW',
      submitErrorInfo:{
        centerDialogVisible : false,//纠错
        ERROR_CONTENT:'',//纠错信息
        ERROR_TYPE: 1,
        errorCorrectionOptions: [{
          value: 1,
          label: '题目内容错误'
        }, {
          value: 2,
          label: '格式错误'
        }, {
          value: 3,
          label: '答案错误'
        }, {
          value: 4,
          label: '其他错误'
        }]
      },
      countDownObj:{type:1,limitTime:0,forceRefresh:true},//切换forceRefresh值实现组件刷新
      // 定时器信息 每分钟执行 记录最新做题时间
      authTimeTimer:null,
      zmArr:['一','二','三','四','五','六','七','八','九','十']
    }
  },
  watch:{
    screenHeight(){     //如果clientHeight 发生改变，这个函数就会运行
      return this.screenHeight
    }
  },
  created(){
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    if(flag){
      this.pageShow = 1
    }
 },
  mounted() {
    this.screenHeight = document.body.clientHeight;
    var that = this;
    window.onresize = () => {
      return (() => {
        that.screenHeight = document.body.clientHeight;
      })();
    };
    window.onresize = function temp() {
        if(document.querySelector('.dtk_title_box') && document.querySelector('.dtk_title_box').offsetHeight){
            var titleHei = document.querySelector('.dtk_title_box').offsetHeight;
            that.examPaperHeight = titleHei+5;
            this.that = document.body.clientHeight;
        }
    };

    //判断是否是请求地址传递的参数
    //请求地址传递的参数
    var paramsJson = this.$route.query;
    var kw_param = paramsJson.kw_param;
    if(kw_param) {
      kw_param = window.atob(kw_param);
      paramsJson = JSON.parse(kw_param);
    } else {
      paramsJson = this.$route.params;
    }

    //判断是否有初始的试题显示类型 如果有则赋值给showType
    if(that.initShowType) {
      that.showType = that.initShowType;
      that.nowQuestionShowType = that.initShowType;
    } else if(paramsJson && paramsJson.initShowType) {
      that.showType = paramsJson.initShowType*1;
      that.nowQuestionShowType = that.initShowType*1;
    }
    //试卷主键
    if(that.initExamPaperId) {
      that.examPaperId = that.initExamPaperId;
    } else if(paramsJson && paramsJson.initExamPaperId) {
      that.examPaperId = paramsJson.initExamPaperId*1;
    }
    //学员主键
    if(that.initStuId) {
      that.stuId = that.initStuId;
    } else if(paramsJson && paramsJson.initStuId) {
      that.stuId = paramsJson.initStuId*1;
    }
    //学员试卷主键
    if(that.initStudentExamPaperId) {
      that.studentExamPaperId = that.initStudentExamPaperId;
    } else if(paramsJson && paramsJson.initStudentExamPaperId) {
      that.studentExamPaperId = paramsJson.initStudentExamPaperId*1;
    }

    //项目ID

    if(that.initProId) {
      that.proId = that.initProId;
    } else if(paramsJson && paramsJson.initProId) {
      that.proId = paramsJson.initProId;
    }

    //进行后台加载试卷信息
    if(that.examPaperId == 0 ) {
      that.showType = 3;
    }
    that.getSysSet();
  },
  beforeDestroy(){
    if (this.authTimeTimer) {
      clearInterval(this.authTimeTimer);
    }
  },
  methods: {
    //提示框组件
    scrollReadingText(num){
//      num数值表示不同位置调用的提示框
      var title,text,text2,num;
      var that = this;
      if(num == 1){
        title = 'More Text';
        text = 'You should use the scroll bar to read the whole passage before you begin to answer the questions.';
        text2 = 'The passage will appear again with each question.';
        num = 1
      }
      if(num == 2){
        title = 'Finish Warning';
        text = 'You have seen all of the questions in this part of Reading Task.You may go back and Review. As long as there is time remaining, you can check your work.';
        text2 = 'Click on Return to continue working.Click on Continue to go on.Once you leave this part of the Reading Task, you WILL NOT be able to return to it';
        num = 2
      }
      theConfirm({
        type:title,
        msg:text,
        msg2:text2,
        btn:{
          //按钮个数
          num:num,
        }
      }).then(() => {
        that.getQuestionShowTypeNext(1);
      }).catch(() => {
        console.log('no')
      })
    },
    /**
     * 显示隐藏倒计时
     */
    switchTime(){
      this.switchTimeShow = !this.switchTimeShow;
      if(this.switchTimeShow == true){
        this.SHOWHIDE = 'SHOW'
      }
      if(this.switchTimeShow == false){
        this.SHOWHIDE = 'HIDE'
      }
    },
    nullFunction(){},
    /**
     * 获取系统设置信息
     */
    getSysSet(){
      var that = this;
      var url = "/model_getSysSet.do";
      var toHtData = {};
      toHtData.tableName = "XCX_SYS_SET";
      toHtData.proId = that.proId;
      this.$axios.post(url,toHtData).then(res => {
        if (res.data) {
          var sysSetInfo = res.data.XCX_SYS_SET;
          //学员试卷的 对象信息
          var tablePageInfo = {};
          tablePageInfo.tableId = sysSetInfo.DOEXAMPAPER_TABLE;
          tablePageInfo.addPageId = sysSetInfo.DOEXAMPAPER_ADD_PAGE;
          tablePageInfo.updatePageId = sysSetInfo.DOEXAMPAPER_UPDATE_PAGE;
          tablePageInfo.timePageId = sysSetInfo.TIME_PAGE_ID;
          that.tablePageInfo = tablePageInfo;
          //学员试题的对象信息
          var doQtablePageInfo = {};
          doQtablePageInfo.tableId = sysSetInfo.DOQUESTION_TABLE;
          doQtablePageInfo.addPageId = sysSetInfo.DOQUESTION_ADD_PAGE;
          doQtablePageInfo.updatePageId = sysSetInfo.DOQUESTION_UPDATE_PAGE;
          that.doQtablePageInfo = doQtablePageInfo;
          that.zdyMounted();
        } else {
          alert("没有获取到题库相关设置信息,请联系管理员");
        }
      }).catch(error => {
        console.log("=====" + error);
        alert("没有获取到题库相关设置信息,请联系管理员");
      })
    },
    zdyMounted(){
      var that = this;
      //去后台请求本套试卷的信息
      that.getExamPaperInfo();
    },
    //答题卡功能切换
    cutShow(){
      this.scantron = !this.scantron
    },
    //刷新页面的计时显示
    addUseTime() {
      this.examPaperInfo.ACTUAL_TIME_LENGTH = this.examPaperInfo.ACTUAL_TIME_LENGTH + 1;
//      this.countTimeStr = "用时:"+utils.formatSeconds(this.examPaperInfo.ACTUAL_TIME_LENGTH);
      this.countTimeStr = utils.formatSeconds(this.examPaperInfo.ACTUAL_TIME_LENGTH);
    },
    /**
     * 进行后台加载试卷信息的查询
     */
    getExamPaperInfo(){
      var that = this;
      //根据试卷主键 examPaperId
      var examPaperId = this.examPaperId;
      //学员主键
      var stuId = this.stuId;
      //学员试卷主键
      var studentExamPaperId = this.studentExamPaperId;
      var url = "/vueQuestion_getExamPaperInfo.do";
      var toHtData = {};
      toHtData.examPaperId = examPaperId;
      toHtData.studentExamPaperId = studentExamPaperId;
      toHtData.proId = that.proId;
      that.isLoading = false;
      this.$axios.post(url,toHtData).then(res => {
        if (res.data) {
          var examPaperInfo = res.data;
          console.log("examPaperInfo=================",examPaperInfo);
          if(!examPaperInfo.ACTUAL_TIME_LENGTH) {
            examPaperInfo.ACTUAL_TIME_LENGTH = 0;
          }
          //examPaperInfo.ZD_DO_WAY = 1;
          if(!examPaperInfo.setInfo) {
              examPaperInfo.setInfo = {
                cssSet:{
                  cssType : 1,//样式表设置
                  flexType : 1,//题目和试题结构设置
                  dtkSet : 1,//答题卡设置
                  czlPosition : 1//操作栏位置
                }
              }
          }
          if(examPaperInfo.ZD_SET_DO_WAY == 1 && !examPaperInfo.ZD_DO_WAY) {
            examPaperInfo.ZD_DO_WAY = 1;
          }
          // 如果是按照常规类型进行显示 则
          if(that.initLookType == 1) {
            examPaperInfo.setInfo = {
              cssSet:{
                cssType : 1,//样式表设置
                flexType : 1,//题目和试题结构设置
                dtkSet : 1,//答题卡设置
                czlPosition : 1//操作栏位置
              }
            }
            examPaperInfo.ZD_DO_WAY = 0;
          }

          that.examPaperInfo = examPaperInfo;

          // 如果是按道显示 则判断初始题的状态 是否可做
          //if(examPaperInfo.ZD_DO_WAY == 1) {
          //  that.getQuestionShowType(0);
          //}
          //进行计时
          if(that.showType == 3) {
            setInterval(that.addUseTime, 1000);
          } else {
            that.addUseTime();
          }
          //判断是否有试卷前置页面 或者 第一个试题块的前置页面
          that.openPrevSet();
          //试卷信息加载完成后 进行试卷显示
          that.isLoading = true;
          // 开始进行每分钟记录 最新修改时间
          that.timeRecordNewTime();
          console.log("examPaperInfo=========11*************1111====================",that.examPaperInfo);
          that.$nextTick(function(){
            if(document.querySelector('.dtk_title_box')) {
              var titleHei = document.querySelector('.dtk_title_box').offsetHeight;
              that.examPaperHeight = titleHei+5;
              console.log("titleHei=========111111====================",titleHei);
            }
          });
        } else{
          //没有获取到试卷信息 可以进行试卷编辑
          that.showType = 0;
          that.$message({
            showClose: true,
            message: "没有获取到试卷信息 可以进行试卷编辑",
            type: 'error'
          });
        }
      }).catch(error => {
        console.log("=====" , error);
      })

    },
    /**
     * 上一道
     */
    prevQuestion(){
      var that = this;
      //上一题如果已做 则进入试题查看页面  

      //判断学员试题主键是否存在 如果存在 则nowQuestionShowType为查看(5) 否则为做题(3)
      that.getQuestionShowType(-1);
    },
    /**
     * 下一道
     */
    nextQuestion(){
      var that = this;
      //判断是否已做
      var questionList = that.examPaperInfo.blockList[that.nowCheckBlock].questionList;
      var questionOne = questionList[that.nowCheckQuestion];
      var dtkQuestionOne = that.examPaperInfo.dtkQuestionList[that.nowCheckQuestionDtk];
        //当试题需保存才能下一步时
        if(that.buttonType.setIfConfirm==false){
            that.buttonType.limitNext = !that.buttonType.limitNext
        }
      //提交过的是否还可修改
      var ifUpdate = 1;
      //如果当前题是已做状态 则直接进入下一题
      if(ifUpdate == 2 && questionOne.studentQuestionId > 0) {
        that.getQuestionShowType(1);
      } else {
          //判断是否 最后一题的 下一题 如果是 则进行交卷提示 如果是
          if(that.nowCheckQuestionDtk == that.examPaperInfo.dtkQuestionList.length-1) {
            if(that.showType != 5) {
              that.$confirm('确认提交整个试卷么？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                customClass:'comfirm_zdy',
                type: 'warning'
              }).then(() => {
                that.saveExamPaper();
              }).catch(() => {
                
                })
            }
          } else {
              that.getQuestionShowType(1);
          }

      }
    },

    /**
     * 修改试题中的 学员试题主键  并进入下一道题
     */
    updateStudentQuestionId(questionIndex,studentQuestionId,stuDoQuestionInfo){
      var that = this;
      console.log("=======questionIndex=======",questionIndex);
      console.log("studentQuestionId=======questionIndex=======",studentQuestionId);
      var questionOne = that.examPaperInfo.blockList[that.nowCheckBlock].questionList[that.nowCheckQuestion];
      questionOne.studentQuestionId = studentQuestionId;
      questionOne.studentQuestionInfo = stuDoQuestionInfo;
      that.getQuestionShowType(1);
    },


    /**
     * 获取试题的 showType类型
     */
    getQuestionShowType(indexType) {
      var that = this;
      //判断是否有倒计时 根据倒计时类型判断 是块的倒计时(判断是否是块的最后一题) 还是 试题的倒计时
      if(indexType == 1 && that.countDownObj.nowTime > 0) {
        var ifTimeFlag = false;
        if(that.countDownObj.type == 1) {
          //块的倒计时 判断是否是块的最后一题
          var dtkCheckMap = that.examPaperInfo.dtkQuestionList[that.nowCheckQuestionDtk+1];
    //      console.log("dtkCheckMap========================",that.nowCheckQuestionDtk,dtkCheckMap);
          if(dtkCheckMap.blockIndex != that.nowCheckBlock) {
            ifTimeFlag = true;
          }

        } else if(that.countDownObj.type == 2) {
          //试题倒计时  进行提示
          ifTimeFlag = true;
        }
        if(ifTimeFlag) {
          this.scrollReadingText(2);
          return;
        }
      }
      this.getQuestionShowTypeNext(indexType);
    },
    getQuestionShowTypeNext(indexType){
      var that = this;
      if(indexType == 1) {
        //答题卡个数加1
        that.nowCheckQuestionDtk++;
        
      } else if(indexType == -1){
        that.nowCheckQuestionDtk--;
      }
        that.examPaperInfo.dtkQuestionList[that.nowCheckQuestionDtk].IF_SEE = 1;
      that.getQuestionIndexByDtkIndex();
      
      //提交过的是否还可修改
      var ifUpdate = 1;
      if(ifUpdate == 2) {
        var questionList = that.examPaperInfo.blockList[that.nowCheckBlock].questionList;
        var studentQuestionId = questionList[that.nowCheckQuestion].studentQuestionId;
        if(studentQuestionId > 0) {
          that.nowQuestionShowType = 5;
        } else {
          that.nowQuestionShowType = 3;
        }
      }
    },
    /**
     * 答题卡切换时 根据答题卡定位是那道大题 或者那道小题
     */
    getQuestionIndexByDtkIndex(){
      var that = this;
      //获取答题卡的试题信息
      var dtkCheckMap = that.examPaperInfo.dtkQuestionList[that.nowCheckQuestionDtk];
      var ifBlockFlag = false;
//      console.log("dtkCheckMap========================",that.nowCheckQuestionDtk,dtkCheckMap);
      if(dtkCheckMap.blockIndex != that.nowCheckBlock) {
        ifBlockFlag = true;
      }
      that.nowCheckBlock = dtkCheckMap.blockIndex;
      that.nowCheckQuestion = dtkCheckMap.questionIndex;
      if(ifBlockFlag) {
        that.blockChangeFun();
      }
      // 下一题时 判断是否出现 ok的确认提交按钮
      var nowQuestion = that.examPaperInfo.blockList[that.nowCheckBlock].questionList[that.nowCheckQuestion];
      if(nowQuestion.questionInfo.cssSet.ifConfirm && nowQuestion.questionInfo.cssSet.ifConfirm == 1){
        this.buttonType.setIfConfirm = false
      }else{
        this.buttonType.setIfConfirm = true
      }

     console.log("nowCheckBlock==============nowCheckQuestion=======",that.nowCheckBlock,that.nowCheckQuestion,dtkCheckMap.childQuestionIndex);
      if(dtkCheckMap.childQuestionIndex>=0){
        that.examPaperInfo.blockList[that.nowCheckBlock].questionList[that.nowCheckQuestion].questionInfo.initChildIndex = dtkCheckMap.childQuestionIndex;
        that.$nextTick(function(){
          var nowQuestionRef = this.$refs.question_info;
          console.log("nowQuestionRef============================",nowQuestionRef);
          if(nowQuestionRef) {
            nowQuestionRef.showQuestionIndex(dtkCheckMap.childQuestionIndex);
          }
        })
      }
      
      console.log("ifBlockFlag============================",ifBlockFlag);
      if(ifBlockFlag) {
        if(that.showType == 3) {
          that.saveExamPaper(1);
        }
      }
    },

    /**
     * 保存试卷
     * saveType:保存类型(1:后台保存 不进行对学员提示)
     */
    saveExamPaper(saveType){
      var that = this;
      //判断试题是添加还是修改功能
      //根据试题主键 examPaperId
      var examPaperId = this.examPaperId;
      //做题类型
      var showType = this.showType;
      //学员主键
      var stuId = this.stuId;
      //学员试卷主键
      var studentExamPaperId = this.studentExamPaperId;
      var examPaperInfo = this.examPaperInfo;


      var url = "/vueQuestion_doExamQuestion.do";
      this.fullscreenLoading = true;
      var toHtData = {};
      //学员主键
      toHtData.STU_ID = stuId;
      //试卷主键
      toHtData.EXAM_PAPER_ID = examPaperId;
      //学员试卷
      toHtData.mainDataId = studentExamPaperId;
      //做题时长
      toHtData.DO_TIME = examPaperInfo.ACTUAL_TIME_LENGTH;

      //做题形式字段 zd_do_way
      toHtData.ZD_DO_WAY = examPaperInfo.ZD_DO_WAY;

      //答案显示规则 zd_anwser_way
      toHtData.ZD_ANWSER_WAY = examPaperInfo.ZD_ANWSER_WAY;

      // 做题状态 
      if(saveType != 1) {
        toHtData.DO_STATE = 3;
      } else {
        toHtData.DO_STATE = 2;
      }

      //考试日期
      if(examPaperInfo.EXAM_DATE) {
        toHtData.EXAM_TIME = utils.dateFormat(new Date(examPaperInfo.EXAM_DATE),"yyyy-MM-dd HH:mm:ss");
      }
      //循环获取 试题的做题情况
      console.log("this.$refs====================",this.$refs);
      var saveLoading = null;
      if(saveType != 1) {
        if (that.authTimeTimer) {
          clearInterval(that.authTimeTimer);
        }
        saveLoading = that.$loading({
          lock: true,
          text: '保存并批改客观题中,请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      }

      var blockList = this.examPaperInfo.blockList;
      if(blockList) {
        //试题主键
        toHtData.QUESTION_ID = "";
        //学员试题主键
        toHtData.QUESTION_mainID = "";
        //试题来源
        toHtData.ZD_SOURCE = "";
        //对错
        toHtData.IF_RIGHT = "";
        //得分
        toHtData.GET_SCORE = "";
        //点评
        toHtData.CHECK_REMARK = "";
        //试卷试题的分值
        toHtData.EPQ_SCORE = "";
        //试题个数
        var questionNum = 0;
        //循环块信息
        var allQIndex = 0;
        blockList.forEach((blockOne,blockIndex) => {
          var blockQuestionList = blockOne.questionList;
          blockQuestionList.forEach((questionOne,questionIndex) => {
            console.log("questionOne====================================",questionOne);
            var oneQuestionInfo = examUtils.getDoQuestionAnwerInfo(questionOne.questionInfo,questionOne.studentQuestionInfo);
            console.log("oneQuestionInfo================================",oneQuestionInfo);
            if(!(blockIndex == 0 && questionIndex == 0)) {
              toHtData.QUESTION_ID += "♆";
              toHtData.QUESTION_mainID += "♆";
              toHtData.ZD_SOURCE += "♆";
              toHtData.IF_RIGHT += "♆";
              toHtData.GET_SCORE += "♆";
              toHtData.CHECK_REMARK += "♆";
              toHtData.EPQ_SCORE += "♆";
            }
            toHtData.QUESTION_ID += questionOne.questionInfo.eqId;
            toHtData.QUESTION_mainID += questionOne.studentQuestionId;
            toHtData.ZD_SOURCE += "1";
            toHtData["eqOption_"+allQIndex] = oneQuestionInfo.eqOption;
            toHtData["eqAnswer_"+allQIndex] = oneQuestionInfo.eqAnswer;
            toHtData["eqAnswer1_"+allQIndex] = oneQuestionInfo.eqAnswer1;
            toHtData["eqAnswerFileAddress_"+allQIndex] = oneQuestionInfo.eqAnswerFileAddress;
            toHtData["eqAnswerFileType_"+allQIndex] = oneQuestionInfo.eqAnswerFileType;
            toHtData.IF_RIGHT += oneQuestionInfo.IF_RIGHT;
            toHtData.GET_SCORE += oneQuestionInfo.GET_SCORE;
            toHtData.CHECK_REMARK += oneQuestionInfo.CHECK_REMARK;
            toHtData.EPQ_SCORE += oneQuestionInfo.EPQ_SCORE;
            //判断试题类型如果为阅读题 则获取阅读题下的子题信息 进行后台传递
            var eqType = questionOne.questionInfo.eqType;
            if(eqType == 9) {
              //判断如果试题类型为 阅读题 则获取阅读题子试题的答案信息
              var ydToHtData = examUtils.getYdDoQuestion(questionOne.questionInfo,questionOne.studentQuestionInfo);
              for (var ydKey in ydToHtData) {
                toHtData[ydKey] = ydToHtData[ydKey];
              }
            }
            allQIndex++;
          });
          questionNum+=blockQuestionList.length;
        })
        //试题个数
        toHtData.QUESTION = questionNum;
      }

      toHtData.showType = showType;
      toHtData.tableId = this.tablePageInfo.tableId;
      if(studentExamPaperId > 0) {
        //修改页面
        toHtData.pageId = this.tablePageInfo.updatePageId;
      } else {
        //添加页面
        toHtData.pageId = this.tablePageInfo.addPageId;
      }
      toHtData.isInterFace=1;


     console.log('*******0123456789*******');
      this.$axios.post(url,toHtData).then(res => {
        that.fullscreenLoading = false;
        if(saveType != 1) {
          saveLoading.close();
        }

        if(res.data) {
          if(saveType != 1) {
            var confirmContent = "交卷成功!查看客观题结果";
            if(that.showType == 4) {
              confirmContent = "批改试卷交卷成功!";
            }
            
            that.showType = 5;
            that.$confirm(confirmContent, '提示', {
              confirmButtonText: '查看',
              cancelButtonText: '关闭',
              customClass:'comfirm_zdy',
              type: 'warning'
            }).then(() => {
              console.log("window.location.href===============",window.location.href);
              console.log("this.$route.path===============",that.$route.path);
              console.log("this.$route.params===============",that.$route.params);
              console.log("this.$route.query===============",that.$route.query);
                var routePath = that.$route.path;
                // routePath = routePath.replace("/3/","/5/");
                if(routePath.indexOf("/3/")>=0 || routePath.indexOf("/4/")>=0) {
                  routePath = routePath.replace("/3/","/5/");
                  routePath = routePath.replace("/4/","/5/");
                  that.$router.replace({ 
                      path:routePath
                  });
                  console.log("window.location.href======2222=========",window.location.href);
                    // console.log("window.location.reload======333=========",window.location.reload);
                  window.location.reload();
                  // that.$router.go(0);
                } else {
                  var paramsJson = that.$route.query;
                  var kw_param = paramsJson.kw_param;
                  kw_param = window.atob(kw_param);
                  paramsJson = JSON.parse(kw_param);
                  paramsJson.initShowType = "5";
                  if(res.data.indexOf("!")>0) {
                    var dataArr = res.data.split("!");
                    paramsJson.initStudentExamPaperId = dataArr[0]*1;
                  }
                  var jsonStr = JSON.stringify(paramsJson);
                  jsonStr = window.btoa(jsonStr);
                  that.$router.replace({ 
                    name: "vueDoExamPaper", 
                    query: {
                        kw_param:jsonStr
                    }
                  });
                  window.location.reload();
                }

            }).catch((error) => {
              console.log("error=====================",error);
              that.cancelPage(); 
            });
            //保存之后 直接打开试卷查看页面 可以进行结果查看
          } else if(saveType == 1) {
            //后台静默保存 保存后 获取返回的学员试卷主键和学员试题主键 进行绑定
            console.log("zdyResult===============================",res.data);
            if(res.data.indexOf("!")>0) {
              var dataArr = res.data.split("!");
              that.studentExamPaperId = dataArr[0]*1;
              var stuQuestionArr = dataArr[1].split("♆");
              var blockList = that.examPaperInfo.blockList;
              var questionIndex = 0;
              blockList.forEach((blockOne,blockIndex) => {
                var blockQuestionList = blockOne.questionList;
                blockQuestionList.forEach((questionOne) => {
                  var childStuQuestionId = stuQuestionArr[questionIndex];
                  if(childStuQuestionId.indexOf("_") > 0) {
                    var childSqArr = childStuQuestionId.split("_");
                    questionOne.studentQuestionId = childSqArr[0]*1;
                    questionOne.studentQuestionInfo.eqAnswer = childSqArr[1].split(",");
                  } else {
                    questionOne.studentQuestionId = childStuQuestionId*1;
                  }
                  questionIndex++;
                });
              })
            }
          }
        } else {
          that.fullscreenLoading = false;
          if(!saveType) {
            that.$message({
              showClose: true,
              message: "保存失败,请重试!",
              type: 'error'
            });
          }
        }
      }).catch(error => {
        console.log("=====" + error);
      })
    },

    /**
     * 修改答题卡的做题状态
     */
    updateDtkState(questionIndex,ifDo,childQuestionIndex,blockIndex){
     console.log("=======questionIndex=======",questionIndex,ifDo,childQuestionIndex,blockIndex);
     if(this.examPaperInfo.blockList[this.nowCheckBlock]) {
       var dtkIndex = this.examPaperInfo.blockList[blockIndex].questionList[questionIndex].dtkIndex;
      console.log("dtkIndex=======================",this.nowCheckBlock,this.nowCheckQuestion,dtkIndex);
       if(childQuestionIndex > 0) {
         dtkIndex = dtkIndex + childQuestionIndex;
       } 
      console.log("dtkIndex========================",dtkIndex);
       this.examPaperInfo.dtkQuestionList[dtkIndex].IF_DO = ifDo;
     }
    },

    /**
     * 点击答题卡时 切换到对应试题显示
     */
    dtkClick(questionIndex){
//      console.log("prevDoQuestion===============================", this.examPaperInfo.blockList[this.nowCheckBlock].questionList[this.nowCheckQuestion].studentQuestionInfo);
      if(this.pageShow == 1){
        this.scantron = false
      }
      if(this.examPaperInfo.setInfo.cssSet.cssType ==2){
        this.buttonType.hearingButton = true;
      }
      this.nowCheckQuestionDtk = questionIndex;
      if(this.examPaperInfo.ZD_DO_WAY == 1) {
        this.getQuestionShowType(0);
      } else {
      //全部显示时 
        this.$nextTick(() => {
          
          var dtkCheckMap = this.examPaperInfo.dtkQuestionList[this.nowCheckQuestionDtk];
          var blockIndex = dtkCheckMap.blockIndex;
          var questionIndex = dtkCheckMap.questionIndex;
          var twoIndex = dtkCheckMap.childQuestionIndex;
          
          // var tmpQuestionEle = this.$refs.question_info[tmpOneIndex];
          var tmpQuestionEle = this.examPaperInfo.blockList[blockIndex].questionList[questionIndex];
          var questionId = tmpQuestionEle.PK_EXAM_QUESTION;
          // var childEle = tmpQuestionEle.$refs['child_question_'+ tmpQuestionEle.questionId +"_"+twoIndex]
          console.log("=========================",blockIndex,questionIndex,twoIndex,questionId);
          this.$refs.examPaper.scrollTo(0,0);
          // $("#examPaper").animate({scrollTop:"0" + "px"}, 0);
          var childEle = $("#child_question_"+ questionId +"_"+twoIndex);
          if(twoIndex == -1) {
            childEle = $("#question_row_"+questionId);
          }
          var top = 0;
          var childOffset = childEle.offset();
          top = childOffset.top - 140;
          console.log("top=========================",top);
          // $("#examPaper").animate({scrollTop:(top-140) + "px"}, 0);
          this.$refs.examPaper.scrollTo(0,top);
          this.$emit("setScroll",top);
        });
      }
    },
    /**
     * 切换试题的显示内容的按钮事件 1:显示试题 2:显示附件信息 3前置页面(下一页)
     */
    changeQuestionType(type){
      var nowQuestionInfo = this.$refs.question_info;
      console.log("nowQuestionInfo===================",nowQuestionInfo);
      if(type == 1) {
        nowQuestionInfo.showQuestionInfo();
      } else if(type == 2) {
        nowQuestionInfo.showFileInfo();
      } else if(type == 3) {
        //判断是否为试卷本身的 下一页 如果是则进行下一页 如果不是则 进行试题的下一页
        var paperShowType = this.paperShowType;
        if(paperShowType.prevPageArr.length > 0) {
          paperShowType.openPrevIndex++;
          if(paperShowType.openPrevIndex >= paperShowType.prevPageArr.length) {
            paperShowType.openPrevFlag = false;
            paperShowType.openPrevIndex = -1;
            paperShowType.openQuestionFlag = true;
            paperShowType.prevPageArr = [];
//            console.log("openQuestionFlag===================",paperShowType.openQuestionFlag,paperShowType.prevPageArr);
            this.buttonType.openPrevFlag = false;
            this.buttonType.openQuestionFlag = true;
            //获取块的倒计时 进行显示
            var blockId = this.examPaperInfo.blockList[this.nowCheckBlock].E_P_B_ID;
            console.log("blockId============================",blockId);
            console.log("this.examPaperInfo.setInfo============================",this.examPaperInfo.setInfo);
            var limitTime = this.examPaperInfo.setInfo["prevSet_"+blockId].limitTime;
            if(!limitTime) {
              limitTime = 0;
            }
            console.log("limitTime=======================",limitTime);
            this.setCountDownInfo(1,limitTime);
          } else {
            paperShowType.prevPageArr[paperShowType.openPrevIndex].type=1;
            paperShowType.prevPageArr[paperShowType.openPrevIndex].forceRefresh=true;
            this.countDownObj = paperShowType.prevPageArr[paperShowType.openPrevIndex];
            this.countDownObj.forceRefresh = false
            this.$nextTick(() => {
              this.countDownObj.forceRefresh = true
            })
          }
          console.log("paperShowType=======================",paperShowType);
          this.paperShowType = paperShowType;
        } else {
          nowQuestionInfo.nextPrevPage();
        }
      }else if(type == 4){
        nowQuestionInfo.showTestQuestions()
      } else if(type == 5){
        this.buttonType.hearingButton = false;
          //获取当前块 获取块的小题个数
          var startIndex = 0;
          this.examPaperInfo.blockList.forEach((one,index) => {
              if(index < this.nowCheckBlock){
                  startIndex += one.dtkQuestionList.length;
              }
          });
          var endIndex = this.examPaperInfo.blockList[this.nowCheckBlock].dtkQuestionList.length;
          this.examPaperInfo.dtkQuestionList[0].IF_SEE = 1;
          var dtkReviewQuestionList = [];
         console.log("startIndex============",startIndex,endIndex);
          this.examPaperInfo.dtkQuestionList.forEach((one,index) => {
              if(index >= startIndex && index<(startIndex+endIndex)) {
                  one.reviewDtkIndex = index;
                  dtkReviewQuestionList.push(one);
              }
          });
          this.dtkReviewQuestionList = dtkReviewQuestionList;
      } else if(type == 6){
        this.buttonType.hearingButton = true;
          this.dtkReviewQuestionList = [];
      } else if(type == 7) {
        //当试题需保存才能下一步时
        if(this.buttonType.setIfConfirm==false){
            this.buttonType.limitNext = !this.buttonType.limitNext
        }
      }
    },
    changeQuestionState(json){
      //是否打开附件页面
      if(json.openFileFlag!=null) {
        this.buttonType.openFileFlag = json.openFileFlag;
      }
      //是否打开前置页面
      if(json.openPrevFlag != null) {
        this.buttonType.openPrevFlag = json.openPrevFlag;
      }
      //是否显示试题页面
      if(json.openQuestionFlag != null) {
        this.buttonType.openQuestionFlag = json.openQuestionFlag;
      }
      //是否openScript
      if(json.openScript!=null) {
        this.buttonType.openScript = json.openScript;
      }
      //是否openPlayTalk
      if(json.openPlayTalk!=null) {
        this.buttonType.openPlayTalk = json.openPlayTalk;
      }
      //是否continue要改为 禁用状态
      if(json.continueDisabled!=null) {
        this.buttonType.continueDisabled = json.continueDisabled;
      }
    },

    /**
     * 判断试卷是否有前置页面  判断试题块是否有前置页面
     */
    openPrevSet(){
      var that = this;
      if(that.showType == 3) {
        var setInfo = that.examPaperInfo.setInfo;
//        console.log(setInfo,'********0***')
        if(setInfo != null && setInfo != undefined) {
          var paperPrevSet = setInfo.prevSet;
          var prevPageArr = [];
          if(paperPrevSet != null && paperPrevSet != undefined) {
            if(paperPrevSet.ifShow == 1) {
              //试卷的前置页面
              if(paperPrevSet.prevPageArr && paperPrevSet.prevPageArr.length > 0) {
                prevPageArr = paperPrevSet.prevPageArr;
              }
            }
          }
          setInfo.prevSet = null;

          //试卷第一个块的前置页面
          var blockId = that.examPaperInfo.blockList[that.nowCheckBlock].E_P_B_ID;
          paperPrevSet = setInfo["prevSet_"+blockId];
          if(paperPrevSet != null && paperPrevSet != undefined) {
            if(paperPrevSet.ifShow == 1) {
              if(paperPrevSet.prevPageArr && paperPrevSet.prevPageArr.length > 0) {
                paperPrevSet.prevPageArr.forEach((one,index) => {
                    if(one.limitTime == null || one.limitTime==undefined) {
                      one.limitTime = 0;
                    }
                    prevPageArr.push(one);
                });
              }
            }
          }
          if(prevPageArr && prevPageArr.length > 0) {
            setInfo["prevSet_"+blockId].prevPageArr = [];
            var paperShowType = that.paperShowType;
            paperShowType.prevPageArr = prevPageArr;
            paperShowType.openPrevFlag = true;
            paperShowType.openPrevIndex = 0;
            paperShowType.openQuestionFlag = false;
            that.paperShowType = paperShowType;
//            console.log("prevPageArr===================",that.paperShowType.openPrevFlag,that.paperShowType.prevPageArr);
            paperShowType.prevPageArr[paperShowType.openPrevIndex].type=1;
            paperShowType.prevPageArr[paperShowType.openPrevIndex].forceRefresh=true;
            this.countDownObj = paperShowType.prevPageArr[paperShowType.openPrevIndex];

            this.buttonType.openPrevFlag = true;
            this.buttonType.openQuestionFlag = false;
          } 
        }
      }
    },
    /**
     * 块点击事件
     */
    blockClickFun(blockIndex){
      if(this.nowCheckBlock == blockIndex) {
        return;
      }
      //清除定时器的显示
      this.countDownObj={type:1,limitTime:0,forceRefresh:true};

      this.buttonType.continueDisabled=false;

      this.nowCheckBlock = blockIndex;
      this.nowCheckQuestion = 0;
      //切答题卡的 下标
      var nowQuestion = this.examPaperInfo.blockList[this.nowCheckBlock].questionList[this.nowCheckQuestion];
      this.nowCheckQuestionDtk = nowQuestion.dtkIndex;
      nowQuestion.questionInfo.initChildIndex = 0;
      if(nowQuestion.questionInfo.cssSet.ifConfirm && nowQuestion.questionInfo.cssSet.ifConfirm == 1){
        this.buttonType.setIfConfirm = false
      }else{
        this.buttonType.setIfConfirm = true
      }
//      this.$nextTick(function(){
//        var nowQuestionRef = this.$refs.question_info;
//        if(nowQuestionRef) {
//          nowQuestionRef.showQuestionIndex(0);
//        }
//      })
//      console.log("this.nowCheckQuestionDtk====================",this.nowCheckQuestionDtk);
//      console.log("nowQuestion====================",nowQuestion);
      this.blockChangeFun();
    },
    /**
     * 块切换时的方法
     */
    blockChangeFun(){
      var that = this;
      if(that.showType == 3) {
        this.openBlockPrevSet();
      }
    },
    /**
     * 判断当前块是否有前置页面 如果有 则打开前置页面
     */
    openBlockPrevSet(){
      var that = this;
      var setInfo = that.examPaperInfo.setInfo;
      var paperShowType = that.paperShowType;
      if(setInfo != null && setInfo != undefined) {
        var blockId = that.examPaperInfo.blockList[that.nowCheckBlock].E_P_B_ID;
        var paperPrevSet = setInfo["prevSet_"+blockId];
        if(paperPrevSet != null && paperPrevSet != undefined) {
          if(paperPrevSet.ifShow == 1) {
            if(paperPrevSet.prevPageArr && paperPrevSet.prevPageArr.length > 0) {
              paperShowType.prevPageArr = paperPrevSet.prevPageArr;
              paperShowType.openPrevFlag = true;
              paperShowType.openPrevIndex = 0;
              paperShowType.openQuestionFlag = false;
              that.paperShowType = paperShowType;

              var limitTime = paperShowType.prevPageArr[paperShowType.openPrevIndex].limitTime;
              if(!limitTime) {
                limitTime = 0;
              }

              this.buttonType.openPrevFlag = true;
              this.buttonType.openQuestionFlag = false;

              paperShowType.prevPageArr[paperShowType.openPrevIndex].type=1;
              paperShowType.prevPageArr[paperShowType.openPrevIndex].forceRefresh=true;
              paperShowType.prevPageArr[paperShowType.openPrevIndex].limitTime = limitTime;
              this.countDownObj = paperShowType.prevPageArr[paperShowType.openPrevIndex];
              this.countDownObj.forceRefresh = false
              this.$nextTick(() => {
                this.countDownObj.forceRefresh = true
              })
            }
          }
          setInfo["prevSet_"+blockId].prevPageArr = [];
        } else {
          paperShowType.openPrevFlag = false;
          paperShowType.openPrevIndex = -1;
          paperShowType.openQuestionFlag = true;
          paperShowType.prevPageArr = [];
        }
      } else {
        paperShowType.openPrevFlag = false;
        paperShowType.openPrevIndex = -1;
        paperShowType.openQuestionFlag = true;
        paperShowType.prevPageArr = [];
      }
    },


    
    /**
     * 设置按钮的状态
     */
    setButtonState:function(flag){
//      console.log("parentButtonFlag =============",flag);
      this.fullscreenLoading = flag;
    },
    /**
     * 切换预览和编辑状态
     */
    changePreview() {
      this.isPreview = !this.isPreview;
    },
    /**
     * 前置页面倒计时结束执行continue
     */
    timeEndCheckContinue() {
      if(this.buttonType.openPrevFlag){
        this.changeQuestionType(3)
      }
    },
    /**
     * 设置定时器的 时间
     */
    setCountDownInfo(type,limitTime){
      if(limitTime > 0 || this.countDownObj.type == 2) {
        this.countDownObj.forceRefresh = false
        this.countDownObj={type:type,limitTime:limitTime};
        this.$nextTick(() => {
          this.countDownObj.forceRefresh = true
        })
      }
    },
    // 试卷前置页面音频播放结束回调
    prevPageAudioEnd(){

    },
    /**
     * 定时器往后台保存 记录最新的做卷子时间 便于进行学员是否还在做卷子页面的判断
     */
    timeRecordNewTime(){
      var that = this;
      if(this.authTimeTimer) {
        clearInterval(this.authTimeTimer);
      }
      if(this.showType == 3) {

        this.authTimeTimer = setInterval(function(){
            that.toHtSaveNewTime();
        }, 60000);
      }
    },
    /**
     * 去后台保存最新的做卷子时间
     */
    toHtSaveNewTime(){
      var that = this;
      var tablePageInfo = that.tablePageInfo;
      var timePageId = tablePageInfo.timePageId;
      var studentExamPaperId = that.studentExamPaperId;
      if(timePageId > 0 && studentExamPaperId > 0) {
        var url = "/update_updateInfo.do";
        var toHtData = {};
        toHtData.tableId = tablePageInfo.tableId;
        toHtData.pageId = timePageId;
        toHtData.isInterFace = 1;
        toHtData.mainDataId = studentExamPaperId;
        toHtData.NEW_TIME = utils.dateFormat(new Date(),"yyyy-MM-dd HH:mm:ss");
        toHtData.ZD_STATE = 2;
        toHtData.source = 1;
        this.$axios.post(url,toHtData).then(res => {
          if (res.data > 0) {
            console.log("定时器修改最新做题时间:成功");
          } else{
            console.log("定时器修改最新做题时间:失败");
          }
        }).catch(error => {
          console.log("=====" , error);
        })
      }
    },
    /**
     * 提交纠错信息
     */
    submitError(){
      var that = this;
      var url = "/add_addInfo.do";
      var toHtData = this.submitErrorInfo;
      toHtData.tableId = 18463;
      toHtData.pageId = 22553;
      toHtData.isInterFace = 1;
      toHtData.PK_EXAM_PAPER = this.examPaperId;
      toHtData.PK_STUDENT = this.stuId;
      if(this.nowCheckQuestionDtk >= 0) {
        toHtData.PK_QUESTION = this.examPaperInfo.dtkQuestionList[this.nowCheckQuestionDtk].questionId;
      }
      this.$axios.post(url,toHtData).then(res => {
        if (res.data > 0) {
          that.$message({
            showClose: true,
            message: "提交错误信息成功",
            type: 'success'
          });
        } else{
          that.$message({
            showClose: true,
            message: "提交失败,请稍后再试",
            type: 'error'
          });
        }
      }).catch(error => {
        console.log("=====" , error);
      })
      this.submitErrorInfo.centerDialogVisible = false;
    },
    /**
     * 返回上一步页面
     */
    cancelPage() {
      console.log("wx===============================",wx);
      if(this.isWeixinCient() && wx.miniProgram) {
        this.$router.go(-1);
        // wx.miniProgram.navigateBack({
        //   delta: 1
        // })
      } else {
        console.log("document.referrer================",document.referrer);
        // var u = navigator.userAgent,apps = navigator.appVersion;
        // if(!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)){
        //     function Transmit(){};
        //     Transmit('back');//UIWebView调用方法
        //     window.webkit.messageHandlers.Transmit.postMessage('back');//WKWebView调用方法
        // }else if(u.indexOf('Android') > -1 || u.indexOf('Adr') > -1){
        //     function Transmit(){};
        //     window.control.Transmit('back');//安卓调用方法
        // } else {
          if(document.referrer != null && document.referrer.length > 0 && document.referrer.indexOf('model_toList')>0) {
            window.location.href=document.referrer;
          } if(window.parent && typeof(window.parent.$)=="function" && window.parent.$('#make-mainPage-tab')) {
            window.parent.$('#make-mainPage-tab').omTabs('close');
          } else if(window.parent && typeof(window.parent.$)=="function" && window.parent.$('#inner-frame').length > 0){
            window.history.back();
          } else {
            sessionStorage.goBackState="true";
            this.$router.go(-1);
          }
        // }
      }
      // wx.miniProgram.getEnv(function(res) {
      //   alert(res.miniprogram) // true 
      // })
    },
    isWeixinCient(){
      var ua = navigator.userAgent.toLowerCase();
      if(ua.match(/MicroMessenger/i)=="micromessenger") {
          return true;
      } else {
          return false;
      }
    }

  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<!-- Add "Lang='less'" to import less file -->
<style scoped lang="less">
  @import './css/switchStyle.less';
  .hdsec {background: #fff;height: 30px;}
  .secskill {line-height: 30px;padding: 0 5px;font-size: 14px;text-align: center;}
  .secskill span {color: #3366CC;display: inline-block;margin: 0 5px;cursor: pointer;text-decoration: underline;}
  .secskill span:hover{text-decoration: none}
  .hl{color: #3366CC;font-weight: bold;font-size: 16px;}
  /*.contents {width: 80%;margin: 0 auto;padding: 25px 5px 25px 5px;font-size: 16px;}*/
  .contents {width: 100%;font-size: 16px;height: 100%;background-color: #F1E7CA}
  /*.contents_241 {overflow: auto}*/
  .showTupc_a{padding-right: 60px;font-size: 14px;cursor: pointer;color: #fff}
  .showTupc_b{padding-right: 10px;font-size: 14px;cursor: pointer;color: #fff}
  .autside{color: #F48A19;font-size: 12px;}
/* 子表格的DIV增加边框样式 */
.childTableDiv{border-bottom:1px dashed #000;margin-top: 15px;}
/* form表单的元素增加宽度 */
.form_item_class{
    width:100%;
}
/* 添加修改页面的input的样式 宽度 */
.add_or_up_input{
    width:190px;
}
div.questionBigBox{position: absolute;top: 1rem;bottom: 60px;left: 0;right: 0;z-index: 3;overflow: auto;-webkit-overflow-scrolling: touch;}
.question_box{padding: 0; box-sizing: border-box; overflow: hidden;}
.dtk_title_box{position: fixed;top: 0;left: 0;right: 0;z-index: 8;overflow: hidden;box-shadow: 0 2px 10px #888888; background: #fff;}
.dtk_scantron{position: relative;width:100%;min-height: 75px;background: url('../../assets/top.png') no-repeat;background-size: 100% 100%;color: #ffffff;}
.dtk_scantron p{position: absolute;top:3%;font-size: 14px;width: 91%;text-align: center;}
.dtk_title{float: right;text-align: center;margin-right: 1%}
/*.dtk_title h4{display: inline-block; font-weight: normal; padding: 0; margin: 10px 0 0;font-size: 14px}*/
.dtk_title p{margin: 0;}
  .dtk_title p:nth-child(1){margin-top: 25%}
.dtk_div_notdo,.dtk_div_do{display: inline-block;background-color: #909090;border-radius: 8px;height: 15px;line-height: 14px;width: 25px;font-size: 12px;margin: 2% 0.5%;text-align: center;color: #ffffff;cursor: pointer;}
.dtk_div_notdo span,.dtk_div_do span{display: block; height: 100%;}
.dtk_div_notdo:hover,
.dtk_div_do{background-color: #FF8500; color: #fff}
.dtk_border{background-image: url('../../assets/iconbg2.png');background-repeat:no-repeat;background-position-y: center;}
.dtk_div_checked{background: green}
.BtnBigBox{position: fixed;bottom: 0;left: 0;right: 0;}
.BtnBox{text-align: center;}
.BtnBox button{margin: 10px; padding-left: 4em; padding-right: 3em;}
.BtnBox .close{outline: 0;color: #ffffff;background: #94A0AE url('../../assets/icon3.png') no-repeat;background-size: 11%;background-position: 33%  }
.BtnBox .affirm{background: #FF8500 url('../../assets/icon2.png') no-repeat;background-size: 11%;background-position: 33%}

.el-button--primary{background-color: #FF8500;border-color: #FF8500;  }
.dtk_scantron_btn{margin-left: 3px;padding-bottom: 2px;}
  .dtk_scantron_btn span{float: right;line-height: 28px;margin-right: 3px}
  .dtk_scantron_btn .scantron_btn{outline: 0;color: #ffffff;background-repeat: no-repeat;background-size: 11%;background-position: 33%;background:-webkit-linear-gradient(top,#FEB80B,#FE5D0C);background:-o-linear-gradient(bottom,#FEB80B,#FE5D0C);background:-moz-linear-gradient(bottom,#FEB80B,#FE5D0C);background:linear-gradient(to bottom,#FEB80B,#FE5D0C);}
  .icon_right_bottom{margin-left: 5px;margin-top: 3px;padding: 0 7px;background-image: url('../../assets/iconbg3.png');background-repeat: no-repeat;background-size: 85%;background-position-y: 2px;}
  .icon_right_top{margin-left: 5px;margin-top: 3px;padding: 0 7px;background-image: url('../../assets/iconbg4.png');background-repeat: no-repeat;background-size: 85%;background-position-y: 2px;}
  .el-button{padding: 7px 15px;}

  .initLookTypeStyle{position: static;}
</style>
<style>
  .sub_reset .el-badge__content{height: 10px;line-height: 9px;padding: 0 1px;right: 0;}
  .sub_reset .el-badge__content.is-fixed{right: 0}
  .sub_reset .el-badge__content--warning{background-color: #3ED5CC;}

  .top-el-dialog .el-dialog__header{background: #F7F8F9;padding: 10px 20px 10px;}
  .top-el-dialog .el-dialog__headerbtn{top: 10px;}
  .top-el-dialog .el-dialog__title{color: #999;font-size: 14px;padding: 10px 10px 10px 0}

  .el-dialog_div_2 .el-textarea{display: inline-block;width: 278px;height: 78px;}
</style>
